export const theme = {
  colors: {
    // Primary colors
    primary: '#00d4ff',
    primaryDark: '#0099cc',
    primaryLight: '#33ddff',
    
    // Background colors
    background: '#0a0a0a',
    backgroundSecondary: '#111111',
    backgroundTertiary: '#1a1a1a',
    backgroundCard: '#1e1e1e',
    
    // Text colors
    textPrimary: '#ffffff',
    textSecondary: '#b3b3b3',
    textTertiary: '#808080',
    textMuted: '#666666',
    
    // Accent colors
    accent: '#ff6b35',
    accentSecondary: '#4ecdc4',
    success: '#00ff88',
    warning: '#ffaa00',
    error: '#ff4444',
    
    // Border colors
    border: '#333333',
    borderLight: '#444444',
    borderDark: '#222222',
    
    // Gradient colors
    gradientPrimary: 'linear-gradient(135deg, #00d4ff 0%, #0099cc 100%)',
    gradientSecondary: 'linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%)',
    gradientDark: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)',
  },
  
  fonts: {
    primary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    heading: "'Poppins', 'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    logo: "'Lato', sans-serif",
    modern: "'Outfit', 'Inter', sans-serif",
    elegant: "'Playfair Display', 'Georgia', serif",
    mono: "'JetBrains Mono', 'Fira Code', 'Monaco', monospace",
  },
  
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    base: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
    '6xl': '3.75rem',
    '7xl': '4.5rem',
    '8xl': '6rem',
  },
  
  fontWeights: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
  },
  
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '3rem',
    '3xl': '4rem',
    '4xl': '6rem',
    '5xl': '8rem',
  },
  
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  },
  
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    base: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    glow: '0 0 20px rgba(0, 212, 255, 0.3)',
    glowStrong: '0 0 30px rgba(0, 212, 255, 0.5)',
  },
  
  borderRadius: {
    none: '0',
    sm: '0.125rem',
    base: '0.25rem',
    md: '0.375rem',
    lg: '0.5rem',
    xl: '0.75rem',
    '2xl': '1rem',
    '3xl': '1.5rem',
    full: '9999px',
  },
  
  transitions: {
    fast: '0.15s ease-in-out',
    base: '0.3s ease-in-out',
    slow: '0.5s ease-in-out',
  },
};
